import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeHtmlFromString'
})
export class RemoveHtmlFromStringPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let newValue = value.replace(/<\/?[^>]+(>|$)/ig, "");
    return newValue.replace(/&nbsp;/ig, " ");
  }

}
